import {Form, Modal, Spin} from "antd";
import i18n from "i18next";
import React, {useEffect, useState} from "react";
import {userServices} from "../../../services";

export default function AttachTelegramModal({isShow, setIsShow}) {
  const [loading, setLoading] = useState(true);
  const [verifyCode, setVerifyCode] = useState(null);

  useEffect(() => {
    if (isShow) {
      setLoading(false);
      userServices.getTelegramVerifyCode()
        .then((resp) => {
          setVerifyCode(resp);

          setLoading(false);
        });
    }
  }, [isShow]);

  return (
    <Modal
      title={`Телеграм/Макс`}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={null}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Form>
          <b>{i18n.t('modals.attachTelegramModal.text.description')}:</b>
          <ol>
            <li>{i18n.t('modals.attachTelegramModal.text.list.1')} <a target="_blank"
                                       href="https://max.ru/id2462225394_bot">https://max.ru/id2462225394_bot</a> {i18n.t('modals.attachTelegramModal.text.list.2')}
            </li>
            <li>{i18n.t('modals.attachTelegramModal.text.list.3')}</li>
            <li>{i18n.t('modals.attachTelegramModal.text.list.4')}:</li>
          </ol>

          <h1 className="center">
            {verifyCode}
          </h1>
          <div><br/><br/><br/><br/><br/><br/></div>
        </Form>
      </Spin>
    </Modal>
  );
}
